// extracted by mini-css-extract-plugin
export default {"wrapper":"Autorobot_wrapper__nBzjm"};